import React, {Component} from "react";
import {log} from "./Tools";

interface LocalStateType {
    currentText: string,
}
interface PropsType {
    //from parent
    enabled: boolean,
    text: string
    //mapToState

    //Dispatch
}

class Loader extends Component<PropsType, LocalStateType> {

    constructor(props: PropsType) {
        super(props);

        this.state = {
            currentText: this.props.text
        };
    }

    componentDidUpdate(prevProps: any) {
        if (((this.props.text !== prevProps.text) || this.state.currentText === '') && this.props.text.length) {

            let newText;

            if (this.props.text === 'login' || this.props.text === 'getUserData') {
                newText = 'Loading user data';
            } else if (this.props.text.startsWith('getAirlineImages')) {
                newText = 'Loading images';
            } else if (this.props.text.startsWith('getCityImages')) {
                newText = 'Loading images';
            } else if (this.props.text.startsWith('register')) {
                newText = 'Registering new user';
            } else if (this.props.text.startsWith('getPlaneImages')) {
                newText = 'Loading images';
            } else if (this.props.text.startsWith('getTemp')) {
                newText = 'Loading city data';
            } else if (this.props.text.startsWith('getTimeZone')) {
                newText = 'Loading city data';
            } else if (this.props.text.startsWith('flightSave')) {
                newText = 'Saving flight data';
            } else if (this.props.text.startsWith('sendMail')) {
                newText = 'Sending mail';
            } else if (this.props.text.startsWith('reset')) {
                newText = 'Resetting password';
            } else if (this.props.text.startsWith('addairline')) {
                newText = 'Adding airline';
            } else if (this.props.text.startsWith('buy')) {
                newText = 'Opening payment service';
            } else if (this.props.text.startsWith('importEmail')) {
                newText = 'Importing from emails';
            } else if (this.props.text.startsWith('logout')) {
                newText = 'Logging out';
            } else {
                log('no text found for:', this.props.text);
                newText = 'data';
            }

            this.setState({
                currentText: newText
            });
        }
    }

    render() {
        log('renderLoader');

        return (
            <div id="loaderContainer" className={this.props.enabled ? 'on' : 'off'}>
                <div id="loaderCircle">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                         x="0px" y="0px" width="300px" height="300px" viewBox="0 0 300 300"
                         enableBackground="new 0 0 300 300">
                        <defs>
                            <path id="loaderCirclePath"
                                  d=" M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "/>
                        </defs>
                        <circle cx="150" cy="100" r="75" fill="none"/>
                        <g>
                            <use xlinkHref="#loaderCirclePath" fill="none"/>
                            <text>
                                <textPath xlinkHref="#loaderCirclePath">{this.state.currentText}...</textPath>
                            </text>
                        </g>
                    </svg>
                </div>
            </div>
        );
    }
}


export default Loader;
